export const IconTile = ({ children }: { children: React.ReactNode }) => (
  <div className="relative h-12 w-12 shrink-0">
    <div className="absolute -inset-1 rounded-full border border-brand-teal/20 opacity-0 transition-opacity duration-300 group-hover:animate-ring-spin group-hover:opacity-100" />
    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-brand-teal/18 bg-linear-to-br from-brand-teal/12 to-brand-blue/12 text-brand-teal transition-all duration-300 group-hover:border-brand-teal/35 group-hover:from-brand-teal/20 group-hover:to-brand-blue/20 group-hover:shadow-[0_0_20px_rgba(70,192,186,0.15)]">
      {children}
    </div>
  </div>
);
